import { TicketFee } from "../ticket-fee.model";
import { Money } from "../money.model";

export class FeeCollection {
	private static TICKET_FEE = "TICKET_FEE"
	private static BOOKING_FEE = "BOOKING_FEE"
	private static HANDLING_FEE = "HANDLING_FEE"
	private static SYSTEM_CHARGE = "SYSTEM_CHARGE"

	ticketFee: TicketFee
	bookingFee: TicketFee
	handlingFee: TicketFee
	systemCharge: TicketFee

	public static fromTicketFeeList(collection: FeeCollection, fees: TicketFee[]) {
		if (!fees) return collection;
		for (let fee of fees) {
			switch (fee.ticketFeeType) {
				case FeeCollection.TICKET_FEE: collection.ticketFee = fee; break;
				case FeeCollection.BOOKING_FEE: collection.bookingFee = fee; break;
				case FeeCollection.HANDLING_FEE: collection.handlingFee = fee; break;
				case FeeCollection.SYSTEM_CHARGE: collection.systemCharge = fee; break;
			}
		}
		return collection;
	}

	public static create() {

		const collection = new FeeCollection();

		const ticketFee: TicketFee = new TicketFee();
		ticketFee.ticketFeeType = FeeCollection.TICKET_FEE
		ticketFee.fee = new Money();

		collection.ticketFee = ticketFee

		const bookingFee: TicketFee = new TicketFee();
		bookingFee.ticketFeeType = FeeCollection.BOOKING_FEE
		bookingFee.fee = new Money();

		collection.bookingFee = bookingFee

		const handlingFee: TicketFee = new TicketFee();
		handlingFee.ticketFeeType = FeeCollection.HANDLING_FEE
		handlingFee.fee = new Money();

		collection.handlingFee = handlingFee

		const systemCharge: TicketFee = new TicketFee();
		systemCharge.ticketFeeType = FeeCollection.SYSTEM_CHARGE
		systemCharge.fee = new Money();

		collection.systemCharge = systemCharge
		return collection;
	}

	public static toList(fc: FeeCollection): TicketFee[] {
		if (!fc) return []
		let result = []
		if (fc.bookingFee.fee.value)
			result.push(fc.bookingFee)
		if (fc.handlingFee.fee.value)
			result.push(fc.handlingFee)
		if (fc.systemCharge.fee.value)
			result.push(fc.systemCharge)
		if (fc.ticketFee.fee.value)
			result.push(fc.ticketFee)
		return result;
	}

	public static equal(a: FeeCollection, b: FeeCollection) {
		if (
			a.bookingFee.fee.value === b.bookingFee.fee.value &&
			a.ticketFee.fee.value === b.ticketFee.fee.value &&
			a.handlingFee.fee.value === b.handlingFee.fee.value &&
			a.systemCharge.fee.value === b.systemCharge.fee.value
		) return true;
		return false;
	}
}



// WEBPACK FOOTER //
// ./src/app/models/ui/fee-collection.ui-model.ts